/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Directive, ElementRef, Input, OnInit } from '@angular/core';
import { VirtualDndService } from './virtual-dnd.service';

@Directive({
  standalone: false,
  selector: '[ghVirtualDndZone]',
})
export class VirtualDndZoneDirective<T> implements OnInit {
  @Input('ghVirtualDndZone') data: T;

  constructor(private elementRef: ElementRef,
              private virtualDnd: VirtualDndService) {
  }

  ngOnInit(): void {
    this.virtualDnd.registerZone(this.data, this.elementRef.nativeElement);
  }
}
